import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { FormDefinitionText } from "./from-definition";
import cn from "classnames";
import { css } from "@emotion/react";
import { sharedInputStyles } from "./styles";
import React from "react";
import { FormElementWrapper } from "./FormElementWrapper";
import { FormIcon } from "./FormIcon";

export const FormFieldInputElement: ReactTFC<{
  formField: FormDefinitionText;
  value: string;
  setValue: (v: string) => void;
}> = props => {
  return (
    <FormElementWrapper height={props.formField.height}>
      <FormIcon iconAlignment={props.formField.iconAlignment} Icon={props.formField.Icon} />

      <input
        css={sharedInputStyles}
        placeholder={props.formField.placeholder}
        value={props.value}
        onChange={e => props.setValue(e.target.value)}
      />
    </FormElementWrapper>
  );
};
